import React from 'react'
import Button from '../button/Button'
import './serviceCard.css'

function ServiceCard({ service }) {
    return (
        <div className='servicecard'>
            <div className='service_image'>
                <img src={service.imageUrl} />
            </div>
            <div className='service_details'>
                <h3>{service.name}</h3>

                <div className='view_btn'>
                    <Button
                        action={`/service?service=${service.id}`}
                        content="View"
                        contentColor='white'
                        borderRadius="all"
                        buttonColor='main-bg'
                    />
                </div>
            </div>
        </div>
    )
}

export default ServiceCard
